import {
  DepositCheck,
  Donations,
  SayThanks,
  SendThanks,
} from '../../../../assets';
import { buildHashLink } from '../../../../utils';

const donationsLink = `<a href="${buildHashLink(
  'donations'
)}"><u>Donations</u></a>`;

const depositCheckContent = `
  <p title="">To deposit a check, you&rsquo;ll need a mobile device with a built-in camera. Then follow these steps:</p>
  <ol title="">
    <li>
      <div>
        <p>
          Select the&nbsp;<strong>Deposit Check</strong> button located in the left sidebar (desktop) or near the top of any fundraising center page (mobile)
        </p>
        <img src="${DepositCheck}" alt="Deposit Check" />
      </div>
    </li>
    <li>Follow the on-screen prompts to enter the check information and take photos of the check&rsquo;s front and back</li>
    <li>Confirm the donation details on the final screen and submit your check donation</li>
  </ol>
`;

const thankYouMessageContent = `
  <p title="">Sending a personalized thank you message isn&rsquo;t just polite, it also increases the chances that a donor will continue to support you in the future. <br />
    <br />Send a personalized thank you message by following these steps:
  </p>
  <ol title="">
    <li>
      <div>
        <p>Navigate to the ${donationsLink} section of your fundraising center</p>
        <img src="${Donations}" alt="Donations Link" />
      </div>
    </li>
    <li>
      <div>
        <p>Select the&nbsp; <strong>Say thanks&nbsp;</strong>button&nbsp;next to the name of the donor you&rsquo;d like to send a thank you message to </p>
        <img src="${SayThanks}" alt="Say Thanks" />
      </div>
      <ol type="a">
        <li>
          <em>Donors you have already marked as thanked cannot be marked as unthanked. Once you thank a donor who has submitted multiple donations, all of their donations will be marked as thanked.</em>
        </li>
      </ol>
    </li>
    <li>
      <div>
        <p> Choose to send your donor a thank you email message </p>
        <br />
        <img src="${SendThanks}" alt="Send Thanks Nessage" />
      </div>
    </li>
    <li>Edit the default thank you email if you&rsquo;d like to personalize your message</li>
    <li>Click&nbsp; <strong>Send</strong> to send your email thank you message </li>
  </ol>
`;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const managing_donations = {
  id: 'd',
  content: {
    articles: [
      {
        title: 'Deposit a check donation with your mobile phone',
        content: depositCheckContent,
      },
      {
        title: 'Send a thank you message to your donors',
        content: thankYouMessageContent,
      },
    ],
  },
};
